// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class TrafficSummaryFloorResponse implements flatbuffers.IUnpackableObject<TrafficSummaryFloorResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TrafficSummaryFloorResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTrafficSummaryFloorResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficSummaryFloorResponse,
  ): TrafficSummaryFloorResponse {
    return (obj || new TrafficSummaryFloorResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsTrafficSummaryFloorResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficSummaryFloorResponse,
  ): TrafficSummaryFloorResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TrafficSummaryFloorResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  floorName(): string;
  floorName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  floorName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  totalCalls(): string;
  totalCalls(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  totalCalls(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  averageTime(): string;
  averageTime(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  averageTime(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  cat010(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat1120(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat2130(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat3140(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat4150(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat5160(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat6170(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat7180(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat8190(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat91120(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat121150(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat151210(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat211300(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat300Plus(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startTrafficSummaryFloorResponse(builder: flatbuffers.Builder) {
    builder.startObject(17);
  }

  static addFloorName(builder: flatbuffers.Builder, floorNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, floorNameOffset, 0);
  }

  static addTotalCalls(builder: flatbuffers.Builder, totalCallsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, totalCallsOffset, 0);
  }

  static addAverageTime(builder: flatbuffers.Builder, averageTimeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, averageTimeOffset, 0);
  }

  static addCat010(builder: flatbuffers.Builder, cat010: number) {
    builder.addFieldInt32(3, cat010, 0);
  }

  static addCat1120(builder: flatbuffers.Builder, cat1120: number) {
    builder.addFieldInt32(4, cat1120, 0);
  }

  static addCat2130(builder: flatbuffers.Builder, cat2130: number) {
    builder.addFieldInt32(5, cat2130, 0);
  }

  static addCat3140(builder: flatbuffers.Builder, cat3140: number) {
    builder.addFieldInt32(6, cat3140, 0);
  }

  static addCat4150(builder: flatbuffers.Builder, cat4150: number) {
    builder.addFieldInt32(7, cat4150, 0);
  }

  static addCat5160(builder: flatbuffers.Builder, cat5160: number) {
    builder.addFieldInt32(8, cat5160, 0);
  }

  static addCat6170(builder: flatbuffers.Builder, cat6170: number) {
    builder.addFieldInt32(9, cat6170, 0);
  }

  static addCat7180(builder: flatbuffers.Builder, cat7180: number) {
    builder.addFieldInt32(10, cat7180, 0);
  }

  static addCat8190(builder: flatbuffers.Builder, cat8190: number) {
    builder.addFieldInt32(11, cat8190, 0);
  }

  static addCat91120(builder: flatbuffers.Builder, cat91120: number) {
    builder.addFieldInt32(12, cat91120, 0);
  }

  static addCat121150(builder: flatbuffers.Builder, cat121150: number) {
    builder.addFieldInt32(13, cat121150, 0);
  }

  static addCat151210(builder: flatbuffers.Builder, cat151210: number) {
    builder.addFieldInt32(14, cat151210, 0);
  }

  static addCat211300(builder: flatbuffers.Builder, cat211300: number) {
    builder.addFieldInt32(15, cat211300, 0);
  }

  static addCat300Plus(builder: flatbuffers.Builder, cat300Plus: number) {
    builder.addFieldInt32(16, cat300Plus, 0);
  }

  static endTrafficSummaryFloorResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // floor_name
    builder.requiredField(offset, 6); // total_calls
    builder.requiredField(offset, 8); // average_time
    return offset;
  }

  static createTrafficSummaryFloorResponse(
    builder: flatbuffers.Builder,
    floorNameOffset: flatbuffers.Offset,
    totalCallsOffset: flatbuffers.Offset,
    averageTimeOffset: flatbuffers.Offset,
    cat010: number,
    cat1120: number,
    cat2130: number,
    cat3140: number,
    cat4150: number,
    cat5160: number,
    cat6170: number,
    cat7180: number,
    cat8190: number,
    cat91120: number,
    cat121150: number,
    cat151210: number,
    cat211300: number,
    cat300Plus: number,
  ): flatbuffers.Offset {
    TrafficSummaryFloorResponse.startTrafficSummaryFloorResponse(builder);
    TrafficSummaryFloorResponse.addFloorName(builder, floorNameOffset);
    TrafficSummaryFloorResponse.addTotalCalls(builder, totalCallsOffset);
    TrafficSummaryFloorResponse.addAverageTime(builder, averageTimeOffset);
    TrafficSummaryFloorResponse.addCat010(builder, cat010);
    TrafficSummaryFloorResponse.addCat1120(builder, cat1120);
    TrafficSummaryFloorResponse.addCat2130(builder, cat2130);
    TrafficSummaryFloorResponse.addCat3140(builder, cat3140);
    TrafficSummaryFloorResponse.addCat4150(builder, cat4150);
    TrafficSummaryFloorResponse.addCat5160(builder, cat5160);
    TrafficSummaryFloorResponse.addCat6170(builder, cat6170);
    TrafficSummaryFloorResponse.addCat7180(builder, cat7180);
    TrafficSummaryFloorResponse.addCat8190(builder, cat8190);
    TrafficSummaryFloorResponse.addCat91120(builder, cat91120);
    TrafficSummaryFloorResponse.addCat121150(builder, cat121150);
    TrafficSummaryFloorResponse.addCat151210(builder, cat151210);
    TrafficSummaryFloorResponse.addCat211300(builder, cat211300);
    TrafficSummaryFloorResponse.addCat300Plus(builder, cat300Plus);
    return TrafficSummaryFloorResponse.endTrafficSummaryFloorResponse(builder);
  }

  unpack(): TrafficSummaryFloorResponseT {
    return new TrafficSummaryFloorResponseT(
      this.floorName(),
      this.totalCalls(),
      this.averageTime(),
      this.cat010(),
      this.cat1120(),
      this.cat2130(),
      this.cat3140(),
      this.cat4150(),
      this.cat5160(),
      this.cat6170(),
      this.cat7180(),
      this.cat8190(),
      this.cat91120(),
      this.cat121150(),
      this.cat151210(),
      this.cat211300(),
      this.cat300Plus(),
    );
  }

  unpackTo(_o: TrafficSummaryFloorResponseT): void {
    _o.floorName = this.floorName();
    _o.totalCalls = this.totalCalls();
    _o.averageTime = this.averageTime();
    _o.cat010 = this.cat010();
    _o.cat1120 = this.cat1120();
    _o.cat2130 = this.cat2130();
    _o.cat3140 = this.cat3140();
    _o.cat4150 = this.cat4150();
    _o.cat5160 = this.cat5160();
    _o.cat6170 = this.cat6170();
    _o.cat7180 = this.cat7180();
    _o.cat8190 = this.cat8190();
    _o.cat91120 = this.cat91120();
    _o.cat121150 = this.cat121150();
    _o.cat151210 = this.cat151210();
    _o.cat211300 = this.cat211300();
    _o.cat300Plus = this.cat300Plus();
  }

  unpackFields(...fields: string[]): TrafficSummaryFloorResponseT {
    const t = new TrafficSummaryFloorResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("floor_name")) {
      t.floorName = this.floorName();
    }
    if (fieldSet.has("total_calls")) {
      t.totalCalls = this.totalCalls();
    }
    if (fieldSet.has("average_time")) {
      t.averageTime = this.averageTime();
    }
    if (fieldSet.has("cat_0_10")) {
      t.cat010 = this.cat010();
    }
    if (fieldSet.has("cat_11_20")) {
      t.cat1120 = this.cat1120();
    }
    if (fieldSet.has("cat_21_30")) {
      t.cat2130 = this.cat2130();
    }
    if (fieldSet.has("cat_31_40")) {
      t.cat3140 = this.cat3140();
    }
    if (fieldSet.has("cat_41_50")) {
      t.cat4150 = this.cat4150();
    }
    if (fieldSet.has("cat_51_60")) {
      t.cat5160 = this.cat5160();
    }
    if (fieldSet.has("cat_61_70")) {
      t.cat6170 = this.cat6170();
    }
    if (fieldSet.has("cat_71_80")) {
      t.cat7180 = this.cat7180();
    }
    if (fieldSet.has("cat_81_90")) {
      t.cat8190 = this.cat8190();
    }
    if (fieldSet.has("cat_91_120")) {
      t.cat91120 = this.cat91120();
    }
    if (fieldSet.has("cat_121_150")) {
      t.cat121150 = this.cat121150();
    }
    if (fieldSet.has("cat_151_210")) {
      t.cat151210 = this.cat151210();
    }
    if (fieldSet.has("cat_211_300")) {
      t.cat211300 = this.cat211300();
    }
    if (fieldSet.has("cat_300_plus")) {
      t.cat300Plus = this.cat300Plus();
    }
    return t;
  }
}

export class TrafficSummaryFloorResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public floorName: string | Uint8Array | null = null,
    public totalCalls: string | Uint8Array | null = null,
    public averageTime: string | Uint8Array | null = null,
    public cat010: number = 0,
    public cat1120: number = 0,
    public cat2130: number = 0,
    public cat3140: number = 0,
    public cat4150: number = 0,
    public cat5160: number = 0,
    public cat6170: number = 0,
    public cat7180: number = 0,
    public cat8190: number = 0,
    public cat91120: number = 0,
    public cat121150: number = 0,
    public cat151210: number = 0,
    public cat211300: number = 0,
    public cat300Plus: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.floorName === null || this.floorName === undefined) {
      throw new Error('Required field "floor_name" is not set');
    }
    if (this.totalCalls === null || this.totalCalls === undefined) {
      throw new Error('Required field "total_calls" is not set');
    }
    if (this.averageTime === null || this.averageTime === undefined) {
      throw new Error('Required field "average_time" is not set');
    }
    const floorName = this.floorName !== null ? builder.createString(this.floorName!) : 0;
    const totalCalls = this.totalCalls !== null ? builder.createString(this.totalCalls!) : 0;
    const averageTime = this.averageTime !== null ? builder.createString(this.averageTime!) : 0;

    return TrafficSummaryFloorResponse.createTrafficSummaryFloorResponse(
      builder,
      floorName,
      totalCalls,
      averageTime,
      this.cat010,
      this.cat1120,
      this.cat2130,
      this.cat3140,
      this.cat4150,
      this.cat5160,
      this.cat6170,
      this.cat7180,
      this.cat8190,
      this.cat91120,
      this.cat121150,
      this.cat151210,
      this.cat211300,
      this.cat300Plus,
    );
  }

  clone(): TrafficSummaryFloorResponseT {
    const obj = new TrafficSummaryFloorResponseT();
    obj.floorName = this.floorName;
    obj.totalCalls = this.totalCalls;
    obj.averageTime = this.averageTime;
    obj.cat010 = this.cat010;
    obj.cat1120 = this.cat1120;
    obj.cat2130 = this.cat2130;
    obj.cat3140 = this.cat3140;
    obj.cat4150 = this.cat4150;
    obj.cat5160 = this.cat5160;
    obj.cat6170 = this.cat6170;
    obj.cat7180 = this.cat7180;
    obj.cat8190 = this.cat8190;
    obj.cat91120 = this.cat91120;
    obj.cat121150 = this.cat121150;
    obj.cat151210 = this.cat151210;
    obj.cat211300 = this.cat211300;
    obj.cat300Plus = this.cat300Plus;
    return obj;
  }

  equals(other: TrafficSummaryFloorResponseT): boolean {
    if (this.floorName !== other.floorName) return false;
    if (this.totalCalls !== other.totalCalls) return false;
    if (this.averageTime !== other.averageTime) return false;
    if (this.cat010 !== other.cat010) return false;
    if (this.cat1120 !== other.cat1120) return false;
    if (this.cat2130 !== other.cat2130) return false;
    if (this.cat3140 !== other.cat3140) return false;
    if (this.cat4150 !== other.cat4150) return false;
    if (this.cat5160 !== other.cat5160) return false;
    if (this.cat6170 !== other.cat6170) return false;
    if (this.cat7180 !== other.cat7180) return false;
    if (this.cat8190 !== other.cat8190) return false;
    if (this.cat91120 !== other.cat91120) return false;
    if (this.cat121150 !== other.cat121150) return false;
    if (this.cat151210 !== other.cat151210) return false;
    if (this.cat211300 !== other.cat211300) return false;
    if (this.cat300Plus !== other.cat300Plus) return false;
    return true;
  }
}

export function verifyTrafficSummaryFloorResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "floor_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "total_calls");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "average_time");
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 4);
    verifier.checkScalarField(tablePos, 22, 4);
    verifier.checkScalarField(tablePos, 24, 4);
    verifier.checkScalarField(tablePos, 26, 4);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 4);
    verifier.checkScalarField(tablePos, 32, 4);
    verifier.checkScalarField(tablePos, 34, 4);
    verifier.checkScalarField(tablePos, 36, 4);
  } finally {
    verifier.popDepth();
  }
}
